export const QUOTATION_TYPE = {
  NEW: 'Seguro novo',
  ENDORSEMENT: 'Endosso',
};
